import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const PaymentInfoSectionContainer = styled.section`
  padding: 24px 0;
  background-color: ${COLORS.bgWhite};
`

export const PaymentInfoSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const PaymentInfoSectionHeading = styled.h2`
  margin: 0;
  padding: 0 24px;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: ${COLORS.textPrimary};
`

export const PaymentInfoDivider = styled.div`
  margin: 0 24px;
  height: 1px;
  background-color: ${COLORS.borderDefault};
`

export const PaymentInfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 24px;
`

export const PaymentMethodLabel = styled.span`
  flex-shrink: 0;
  width: 49px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${COLORS.textSecondary};
`

export const PaymentInfoMethod = styled.span`
  flex: 1;
  text-align: right;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`
